var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVirtualVehicle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 198.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.5,101.3c-1.6-1.8-2.9-3.9-3.7-6.1l-10-29c-5.4-13.5-16.6-12.3-16.6-12.3H45.4s-11.2-1.3-16.6,12.3l-10,29c-.8,2.3-2,4.4-3.7,6.1-3.7,4.1-10.5,12.4-10.9,20v29.4c0,3.4.9,6.7,2.8,9.4,2.6,3.7,7.4,7.4,16.6,7.4h143.3c9.2,0,14-3.7,16.6-7.4,1.9-2.8,2.8-6.1,2.8-9.4v-29.4c-.4-7.6-7.1-15.9-10.9-20Z",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 15.2,
    y1: 101.4,
    x2: 175.5,
    y2: 101.4,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.4,
    y: 124.2,
    width: 31.5,
    height: 22.7,
    rx: 4,
    ry: 4,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.1,
    y: 123.7,
    width: 31.5,
    height: 22.7,
    rx: 4,
    ry: 4,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 74.3,
    y1: 128.5,
    x2: 116.4,
    y2: 128.5,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 74.3,
    y1: 135.6,
    x2: 116.4,
    y2: 135.6,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 74.3,
    y1: 142.6,
    x2: 116.4,
    y2: 142.6,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6,167.6v12.4c0,6.8-5.6,12.4-12.4,12.4h-13.7c-6.8,0-12.4-5.6-12.4-12.4v-33.4",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,167.6v12.4c0,6.8,5.6,12.4,12.4,12.4h13.7c6.8,0,12.4-5.6,12.4-12.4v-33.4",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.4,
    cy: 16.8,
    r: 10.4,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 130.6,
    cy: 16.5,
    r: 9.1,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "130.6 25.6 130.6 35.8 110 35.8 110 51.4",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 59.7,
    cy: 16.5,
    r: 9.1,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "59.7 25.6 59.7 35.8 80.3 35.8 80.3 51.4",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 95.2,
    cy: 16.8,
    r: 9.1,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95.2,
    y1: 27,
    x2: 95.2,
    y2: 52.9,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVirtualVehicle);
export default __webpack_public_path__ + "static/media/icon-virtual-vehicle.670ec96eadba4c3abac32ed2b19c05ce.svg";
export { ForwardRef as ReactComponent };